import { memo } from "react";
import { Table } from "react-bootstrap";
import trashIcon from "../assets/images/trash-icon.svg";


const CollaboratorsEmail = memo((props) => {

    const { showEmails, removeEmail, setShowEmails, isEditDet } = props

    const handlePermissions = (index, key, value) => {

        let mails = [...showEmails]

        mails[index][key] = value

        setShowEmails(mails)


    }


    return (
        <>
            <Table bordered hover responsive className="custom-table-border1 mt-2" >
                <thead>
                    <tr style={{ height: '20px' }}>
                        <th style={{ fontSize: '14px', textAlign: 'left', padding: '4px' }} className="job_size">Email Id  </th>
                        <th style={{ fontSize: '14px', textAlign: 'left', padding: '4px' }} className="job_size">Daily Mails</th>
                        <th style={{ fontSize: '14px', textAlign: 'left', padding: '4px' }} className="job_size">Edit</th>
                        <th style={{ fontSize: '14px', textAlign: 'left', padding: '4px' }} className="job_size">View</th>
                        <th style={{ fontSize: '14px', textAlign: 'left', padding: '4px' }} className="job_size">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        showEmails.map((email, index) => {
                            return <tr>
                                <td style={{ textAlign: "left", padding: '4px' }}>
                                    <div style={{ fontSize: "14px", color: '#3a4b68' }}>
                                        {email?.email}
                                    </div>
                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <input type="checkbox"
                                        checked={email?.isDailyReportEnabled}
                                        disabled={isEditDet}
                                        onChange={(e) => handlePermissions(index, 'isDailyReportEnabled', e.target.checked)}
                                    />

                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <input type="checkbox"
                                        checked={email?.isEditEnabled}
                                        disabled={isEditDet}
                                        onChange={(e) => {
                                            handlePermissions(index, 'isEditEnabled', e.target.checked)
                                            if (e.target.checked) {
                                                handlePermissions(index, 'isViewEnabled', true)
                                            }
                                        }}
                                    />

                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <input type="checkbox"
                                        checked={email?.isViewEnabled}
                                        disabled={isEditDet}
                                        onChange={(e) => {
                                            handlePermissions(index, 'isViewEnabled', e.target.checked)
                                            if (!e.target.checked) {
                                                handlePermissions(index, 'isEditEnabled', false)
                                            }
                                        }}
                                    />

                                </td>
                                <td className="text-left" style={{ width: '110px', padding: '4px' }}>
                                    <img src={trashIcon} style={{ height: '15px', width: '15px', cursor: 'pointer', marginTop: '-5px' }}
                                        onClick={() => !isEditDet && removeEmail(index)}
                                    />

                                </td>
                            </tr>
                        })
                    }


                </tbody>
            </Table>
        </>
    )

})

export default CollaboratorsEmail